import config from '../config';
import { getToken, login } from '../auth';

const { API_BASE_URL } = config;

async function fetchApi(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;
  const token = getToken();

  const defaultHeaders = {
    'Content-Type': 'application/json',
  };

  if (token) {
    defaultHeaders['Authorization'] = token;
  }

  const fetchOptions = {
    ...options,
    headers: {
      ...defaultHeaders,
      ...options.headers,
    },
  };

  if (options.body && typeof options.body === 'object') {
    fetchOptions.body = JSON.stringify(options.body);
  }

  try {
    const response = await fetch(url, fetchOptions);

    if (response.status === 401) {
      login();
      return;
    }

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      const error = new Error(errorData.error || `Server error: ${response.status}`);
      error.status = response.status;
      if (errorData.details && Array.isArray(errorData.details)) {
        error.details = errorData.details;
      }
      throw error;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    if (error.status) {
      throw error;
    }
    const networkError = new Error(
      'Unable to connect to server. Please check your internet connection and try again.'
    );
    networkError.isNetworkError = true;
    throw networkError;
  }
}

export { fetchApi, API_BASE_URL };
export default fetchApi;
